import CatRootModulePropertiesPane from '../_CAT_ROOT_MODULE/CatRootModulePropertiesPane.jsx'

export default function PropertiesPaneCatRootCm(props) {
    return (
        <CatRootModulePropertiesPane
            {...props}
        />
    )
}
